import { SettingsDropdownHeaderProps } from "@/types/layout";
import Image from "next/image";

export const SettingsDropdownHeader: React.FC<SettingsDropdownHeaderProps> = ({
  title,
  toggleAccordion,
  setToggleAccordion,
}) => {
  return (
    <>
      <div
        className="flex cursor-pointer items-center justify-between px-[24px] py-[12px] transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25"
        onClick={() => setToggleAccordion(!toggleAccordion)}
      >
        <h2 className="text-dark dark:text-white">{title}</h2>
        <Image
          src="/assets/images/icons/chevron-down-dark.svg"
          alt="Chevron Down Icon"
          className={`${toggleAccordion ? "rotate-180" : ""} dark:invert`}
          width={10}
          height={10}
        />
      </div>
    </>
  );
};
